<template lang="html">
  <div class="wrapper" v-bind:class="{'is-active': active}">
    <div class="menu" v-bind:class="{'is-active': active}">
      <div class="links">
        <router-link @click.native="close" to="/about">О подходе</router-link>
        <router-link @click.native="close" to="/companies">Список фабрик</router-link>
        <router-link @click.native="close" to="/contact">Контакты</router-link>
      </div>
      <div class="madebyme">Разработка сайта — <a href="https://aeyoa.com/" target="_blank">Арсений Коган</a></div>
    </div>
    <div class="button open" v-on:click="toggle"></div>
  </div>
</template>

<script>

export default {
  name: 'Menu',
  data: function () {
    return {
      active: false
    }
  },
  methods: {
    open: function () {
      this.active = true;
    },
    close: function () {
      this.active = false;
    },
    toggle: function () {
      this.active = !this.active;
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../scss/settings';
@import '../scss/mixins';

.wrapper {
  height: 100%;
  width: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 99;
}

.wrapper.is-active {
  .menu {
    transform: translateX(0);
    // right: 0;
  }
}

.menu {
  background-color: #000;
  width: 50vw;
  height: 100%;
  color: #fff;
  position: fixed;
  right: 0;
  display: flex;
  align-items: center;
  transform: translateX(100%);
  transition: transform 900ms cubic-bezier(1.000, 0.000, 0.000, 1.000);
}


a {
  color: #fff;
  text-decoration: none;
}

.links a {
  letter-spacing: 0.44px;
  display: block;
  line-height: 36px;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 1em;
  padding: 10px 10px 10px $padding;

}

.madebyme {
  position: absolute;
  bottom: $padding - 3;
  left: $padding;
  font-size: 12px;
  line-height: 1.6em;
  color: rgba(#fff, 0.4);
  padding-right: $padding;
  a {
    color: #fff;
  }
}

.button {
  position: fixed;
  top: $padding;
  right: 0;
  width: 64px;
  height: 53px;
  // background-color: rgba(#fff, 0.1);
  cursor: pointer;

  &::before, &::after {
    content: '';
    position: absolute;
    left: 20px;
    height: 3px;
    width: 24px;
    transform: scaleY(0.5);
    background-color: #fff;
    transform-origin: center left;
    transition: transform 300ms ease, background-color 900ms cubic-bezier(1.000, 0.000, 0.000, 1.000);
  }

  &::before {
    top: 20px;
  }

  &::after {
    top: 31px;
  }

}
.button.open {
  &::before, &::after {
    background-color: #000;
  }
}

.wrapper.is-active {
  .button {
    &::before {
      transform: translate(3px, -3px) rotate(45deg) scaleY(0.5);
      background-color: #fff;
    }
    &::after {
      transform: translate(3px, 3px) rotate(-45deg) scaleY(0.5);
      background-color: #fff;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Menu.vue